import type {SampleErrorQueryVariables} from '../../graphql/generated/types';

/**
 * Dev 도메인 Query Key 관리
 */
export const DEV_QUERY_KEY_MAP = {
  /**
   * 샘플 에러 테스트
   * Origin: useSampleErrorQuery.getKey
   */
  sampleError: (variables: SampleErrorQueryVariables) =>
    ['sampleError', variables] as const,
} as const;
